import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import HotRecommend from './components/HotRecommend';
import CategoryNav from './components/CategoryNav';
import LatestUpdate from './components/LatestUpdate';
import RankingSection from './components/RankingSection';

export default function Home() {
  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '57漫画网',
    alternateName: '蜜桃少年漫画',
    url: 'https://57manhua.com/',
    description: '57漫画网在线免费阅读蜜桃少年漫画全集，畅读全集中文版本，体验免费且便捷的在线浏览服务。',
    inLanguage: 'zh-Hans',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://57manhua.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '57漫画网',
    url: 'https://57manhua.com/',
    description: '中国领先的免费在线漫画阅读平台，提供蜜桃少年漫画等海量优质漫画。',
    email: 'contact@57manhua.com',
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'customer service',
      availableLanguage: ['Chinese'],
    },
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(websiteSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(orgSchema)}</script>

      <Navbar />
      <main>
        <HeroSection />
        <HotRecommend />
        <CategoryNav />
        <LatestUpdate />
        <RankingSection />

        <section className="py-10 md:py-14">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="bg-gradient-to-r from-primary-500 to-accent-500 rounded-2xl p-8 md:p-12 text-center">
              <h2 className="font-heading text-xl md:text-2xl font-bold text-background-50 mb-3">
                随时随地，畅享漫画乐趣
              </h2>
              <p className="text-background-200 text-sm md:text-base max-w-xl mx-auto mb-6">
                57漫画网完美适配手机、平板和电脑，随时随地免费阅读蜜桃少年漫画全集。
              </p>
              <a
                href="/comic/mitao-shaonian"
                className="inline-flex items-center gap-2 px-8 py-3 bg-background-50 text-primary-600 font-bold rounded-full hover:bg-background-100 transition-all duration-300 whitespace-nowrap text-sm md:text-base"
              >
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-book-open-line"></i>
                </div>
                立即阅读
              </a>
            </div>
          </div>
        </section>

        <section className="py-10 md:py-14 bg-background-100">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="text-center mb-8">
              <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">常见问题</h2>
              <p className="text-sm text-foreground-500 mt-1">关于57漫画网的常见疑问解答</p>
            </div>
            <div className="max-w-3xl mx-auto space-y-3">
              {[
                { q: '57漫画网的漫画都是免费的吗？', a: '是的，57漫画网上所有的漫画内容均为免费阅读。我们致力于为广大漫画爱好者提供免费、高质量的漫画阅读体验，无需付费即可畅读蜜桃少年漫画全集及更多精彩作品。' },
                { q: '蜜桃少年漫画多久更新一次？', a: '蜜桃少年漫画目前保持每周更新一话的频率。作者桃花仙人为保证作品质量，每一话都精心绘制，通常在每周五晚间更新。' },
                { q: '57漫画网支持手机阅读吗？', a: '当然支持！57漫画网采用响应式设计，完美适配手机、平板和电脑等多种设备。无论您使用什么设备，都能获得流畅舒适的漫画阅读体验。' },
                { q: '如何在57漫画网搜索想看的漫画？', a: '您可以在首页顶部的搜索框中输入漫画名称或关键词，也可以通过分类页面按类型浏览，涵盖少年漫画、热血、玄幻、恋爱等多种类别。' },
              ].map((faq, i) => (
                <details key={i} className="group bg-background-50 rounded-lg border border-background-200/70 overflow-hidden">
                  <summary className="flex items-center justify-between px-5 py-4 cursor-pointer hover:bg-background-100 transition-colors duration-200">
                    <span className="text-sm md:text-base font-medium text-foreground-950">{faq.q}</span>
                    <div className="w-5 h-5 flex items-center justify-center text-foreground-400 group-open:rotate-180 transition-transform duration-200">
                      <i className="ri-arrow-down-s-line"></i>
                    </div>
                  </summary>
                  <div className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">
                    {faq.a}
                  </div>
                </details>
              ))}
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}